/**
 * 游戏业务弹窗
 */
export default {
  dbl_game_no_access_title: 'Access Denied',
  dbl_game_no_access_content: 'Sorry, you do not have permission to access this game. To request permission, please contact the following team members: sallyxue, v_blljli, or ivyyfchen.',
  dbl_game_no_access_confirm: 'Got it',
};